import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import GolbalMessage from "./../common/globalMessage";
import RestService from "./RestService";
import GlobalHelmet from "../../GlobalHelmet";
import Common from "./../../common.json";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: theme.palette.grey[100],
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  mb100: { marginBottom: "100px" },
}));

export default function SignIn() {
  const classes = useStyles();
  const [submitDisabled, setsubmitDisabled] = useState(false);
  const [noRecordFound, setNoRecordFound] = React.useState(false);

  const validationSchema = Yup.object().shape({
    user_name: Yup.string()
      .required("First Name is required")
      .trim("The contact name cannot include leading and trailing spaces"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
    mobile: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .test(
        "len",
        "Mobile Number must be exactly 10 characters",
        (val) => val.length === 10
      ),
  });
  const { register, handleSubmit, reset, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });
  function onSubmit(fdata) {
    setsubmitDisabled(true);

    let ffdata = new FormData();
    ffdata.append("user_name", fdata.user_name);
    ffdata.append("email", fdata.email);
    ffdata.append("mobile", fdata.mobile);
    ffdata.append("needTrail", fdata.needTrail.join(","));

    RestService.expertEnquiryData(function (res) {
      setNoRecordFound(true);
      reset();
      setsubmitDisabled(false);
    }, ffdata);

    //setsubmitDisabled(true);
    //reset();
  }

  return (
    <Container component="main" maxWidth="sm">
      <GlobalHelmet {...Common.home} />
      <div className={"upperform " + classes.paper}>
        <Typography component="h1" variant="h5">
          Expert Advisory Enquire Now
        </Typography>
        <form
          className={classes.form}
          onSubmit={handleSubmit(onSubmit)}
          onReset={reset}
        >
          <div className="row">
            <div className="col-12">
              {noRecordFound && (
                <div className="alert alert-success" role="alert">
                  {GolbalMessage?.general?.pmsEnquirySuccess}
                </div>
              )}
            </div>
            <div className="col-sm-12">
              <label>Name</label>
              <input
                type="text"
                autoComplete="user_name"
                name="user_name"
                variant="outlined"
                id="user_name"
                label="Name"
                placeholder="Enter Your Name"
                autoFocus
                ref={register}
                className={`form-control ${
                  errors.user_name ? "is-invalid" : ""
                }`}
              />
              <div className="invalid-feedback">
                {errors.user_name?.message}
              </div>
            </div>
            <div className="col-sm-6 mt-2">
              <label>Email</label>
              <input
                type="email"
                variant="outlined"
                id="email"
                label="Email Address"
                name="email"
                placeholder="Enter Email id"
                autoComplete="email"
                ref={register}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{errors.email?.message}</div>
            </div>
            <div className="col-sm-6 mt-2">
              <label>Mobile Number</label>
              <input
                variant="outlined"
                margin="normal"
                id="mobile"
                label="Mobile number"
                name="mobile"
                autoComplete="Mobile Number"
                autoFocus
                ref={register}
                className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{errors.mobile?.message}</div>
            </div>
            <div className="col-sm-12 mt-2">
              <label>Need Trail</label>
            </div>
            <div className="col-sm-12 mt-2">
              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="defaultInline1"
                  name="needTrail"
                  ref={register}
                  value="1"
                />
                <label
                  className="custom-control-label"
                  htmlFor="defaultInline1"
                >
                  Stock Cash
                </label>
              </div>

              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="defaultInline2"
                  name="needTrail"
                  ref={register}
                  value="2"
                />
                <label
                  className="custom-control-label"
                  htmlFor="defaultInline2"
                >
                  Nifty/Bank Nifty Future
                </label>
              </div>

              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="defaultInline3"
                  name="needTrail"
                  ref={register}
                  value="3"
                />
                <label
                  className="custom-control-label"
                  htmlFor="defaultInline3"
                >
                  Intraday Stocks
                </label>
              </div>

              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="defaultInline4"
                  name="needTrail"
                  ref={register}
                  value="4"
                />
                <label
                  className="custom-control-label"
                  htmlFor="defaultInline4"
                >
                  Stock Options
                </label>
              </div>

              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="defaultInline5"
                  name="needTrail"
                  ref={register}
                  value="5"
                />
                <label
                  className="custom-control-label"
                  htmlFor="defaultInline5"
                >
                  Nifty/Bank Nifty Option
                </label>
              </div>
              <div className="invalid-feedback">
                {errors.needTrail?.message}
              </div>
            </div>
          </div>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={submitDisabled}
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
      </div>
    </Container>
  );
}
